module.exports = __webpack_public_path__ + "img/motorway_11x4.57e45aad.svg";